import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Entry from "@/pages/Entry";
import Join from "@/pages/Join";
import Login from "@/pages/Login";
import Contact from "@/pages/Contact";
import AdminDashboard from "@/pages/AdminDashboard";
import { AboutSerenismm, AboutFounder } from "@/pages/public/About";

function App() {
  return (
    <div className="App min-h-screen bg-[#F3EEE4] text-[#2E2A22]">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Private entry / invitation */}
            <Route path="/" element={<Entry />} />
            <Route path="/validate" element={<Join />} />
            <Route path="/invite/:code" element={<Join />} />
            <Route path="/register" element={<Navigate to="/validate" replace />} />

            {/* SUPER_ADMIN */}
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute role="SUPER_ADMIN"><AdminDashboard /></ProtectedRoute>} />

            {/* Public brand pages */}
            <Route path="/about-serenismm" element={<AboutSerenismm />} />
            <Route path="/about-founder" element={<AboutFounder />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
